// Funnel v2 checkout page — one job: get the email, offer the Kit, hand off
// to Stripe. The left column carries reassurance; the right column is the
// order. (Fixes #255 — this page now drives a real checkout.)

import { Lock } from 'lucide-react';
import { CheckoutForm } from '../../components/marketing/CheckoutForm';
import { AssuranceItem, Kicker, ValuePromise } from '../../components/marketing/funnel/atoms';

export function CheckoutPage() {
  return (
    <section className="px-5 py-12 md:px-8 md:py-20">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-start">
        <div className="lg:sticky lg:top-16">
          <Kicker className="!text-brand-teal/90">Secure checkout</Kicker>
          <h1 className="mt-4 font-display text-4xl font-semibold leading-[1.04] tracking-tight text-white md:text-6xl">
            Get your AI Workforce Blueprint.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-8 text-slate-300">
            One-time payment. No subscription on this page. Your guided Blueprint experience
            opens right after checkout and walks you from bottleneck to a deployable AI
            workforce plan.
          </p>

          <div className="mt-8 space-y-3">
            <AssuranceItem>Written plan specific to your business — yours to keep</AssuranceItem>
            <AssuranceItem>Come back to your sessions as often as you want</AssuranceItem>
            <AssuranceItem>Implementation options shown right after checkout</AssuranceItem>
          </div>

          <ValuePromise className="mt-8 max-w-xl" />

          <p className="mt-6 flex items-center gap-2 text-sm text-slate-500">
            <Lock className="h-4 w-4 text-brand-teal" />
            Payment handled end-to-end by Stripe.
          </p>
        </div>

        <div className="rounded-lg border border-white/10 bg-[#0e131b] p-1.5 shadow-2xl shadow-black/40">
          <div className="rounded-md border border-white/10 bg-[#090c12] p-5 md:p-7">
            <CheckoutForm />
          </div>
        </div>
      </div>
    </section>
  );
}
